<div class="min-h-screen flex">
      <div class="hidden lg:flex lg:w-1/2 editorial-gradient relative overflow-hidden items-center justify-center p-12">
        <div class="absolute -top-24 -left-24 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
        <div class="absolute -bottom-32 -right-32 w-[500px] h-[500px] bg-secondary/10 rounded-full blur-3xl"></div>
        <div class="relative z-10 text-center max-w-lg">
          <div class="inline-flex items-center px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm text-white/90 text-sm font-semibold mb-8">
            <span class="material-symbols-outlined text-sm mr-2">neurology</span>
            Aprendizaje Adaptativo
          </div>
          <h1 class="font-headline text-5xl font-extrabold text-white tracking-tight leading-tight mb-6">
            AdaptAI
          </h1>
          <p class="text-white/70 text-lg leading-relaxed mb-10">
            Plataforma de aprendizaje adaptativo multimateria con analítica avanzada y gamificación.
          </p>
          <div class="grid grid-cols-3 gap-4">
            <div class="p-4 bg-white/10 rounded-2xl backdrop-blur-sm border border-white/10">
              <p class="text-3xl font-extrabold text-white">11</p>
              <p class="text-xs text-white/60 mt-1">Grados</p>
            </div>
            <div class="p-4 bg-white/10 rounded-2xl backdrop-blur-sm border border-white/10">
              <p class="text-3xl font-extrabold text-tertiary-fixed-dim">5</p>
              <p class="text-xs text-white/60 mt-1">Subniveles</p>
            </div>
            <div class="p-4 bg-white/10 rounded-2xl backdrop-blur-sm border border-white/10">
              <p class="text-3xl font-extrabold text-secondary-fixed-dim">∞</p>
              <p class="text-xs text-white/60 mt-1">Adaptación</p>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-12 bg-surface">
        <div class="w-full max-w-md">
          <router-outlet />
        </div>
      </div>
    </div>